module.exports = __webpack_public_path__ + "img/tnt.32b44795.svg";